import { toast } from 'sonner';

// Re-export the API constant from config for consistent usage
import { API } from '@/config';

export const logError = (context, error) => {
  const timestamp = new Date().toISOString();
  console.error(`[${timestamp}] Error in ${context}:`, error);
  
  if (error.response) {
    console.error('Response Data:', error.response.data);
    console.error('Response Status:', error.response.status);
    console.error('Response Headers:', error.response.headers);
  } else if (error.request) {
    console.error('No response received:', error.request);
  } else {
    console.error('Error setup:', error.message);
  }
};

export const debugLog = (message, data = {}) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`[DEBUG] ${message}`, data);
  }
};

// Network checker
export const checkApiHealth = async () => {
  try {
    const healthUrl = `${API}/health`;
    console.log(`Checking API health at: ${healthUrl}`);
    
    const response = await fetch(healthUrl);
    
    // Check for JSON content type
    const contentType = response.headers.get("content-type");
    if (response.ok && contentType && contentType.includes("application/json")) {
        const data = await response.json();
        console.log('API Health Check:', data);
        return true;
    } else {
        const text = await response.text();
        console.error(`API Health Check Failed: ${response.status} ${response.statusText}`, text.slice(0, 100));
        throw new Error(`API returned ${response.status}`);
    }
  } catch (error) {
    console.error('API Health Check Failed:', error);
    toast.error('Cannot connect to server. Please check your internet connection.');
    return false;
  }
};
